var PUBLIC_ASSET_PREFIX = process.env.REACT_APP_PUBLIC_ASSET_PREFIX;
export var FONT_FAMILY = "TT Hoves Pro";
var font = function (name, weight) { return ({
    src: "".concat(PUBLIC_ASSET_PREFIX, "/public/v1/fonts/TT_Hoves_Pro/").concat(name, ".woff2"),
    weight: weight,
}); };
export var FONT_FACES = [
    font("TT_Hoves_Pro_Regular", 400),
    font("TT_Hoves_Pro_Medium", 500),
];
